import BaseService from "@/boot/BaseService";
class PresupuestoService extends BaseService {
    constructor() {
        super(null, "/presupuestos");
    }
    async grid(params) {
        return await this.get("/grid", params);
    }
    async kanban(params) {
        return await this.get("/kanban", params);
    }
    async show(id) {
        return await this.get(`/${id}`);
    }

    async store(formData) {
        return await this.post("", formData);
    }

    async update(id, formData) {
        return await this.put(`/${id}`, formData);
    }
    async list(filter, cliente) {
        return await this.post("/list", { filter, cliente });
    }
    async estadoUpdate(presupuesto, estado) {
        return await this.post("/estado", { presupuesto, estado });
    }
    async itemAdd(presupuestoId, item) {
        return await this.post("/item-add", { presupuestoId, item });
    }
    async itemUpdate(presupuestoId, item) {
        return await this.post(`/item-update/${presupuestoId}`, { item });
    }
    async itemDelete(presupuestoId, itemId) {
        return await this.post(`/item-delete/${itemId}`, { presupuestoId });
    }

    async accesorioDelete(presupuestoId, itemId) {
        return await this.post(`/accesorio-delete/${itemId}`, {
            presupuestoId,
        });
    }

    async presupuestoSplit(presupuestoId, items) {
        return await this.post(`/split/${presupuestoId}`, { items });
    }

    async presupuestoClonar(presupuestoId) {
        return await this.post(`/clonar/${presupuestoId}`);
    }

    async desacopio(presupuestoId, items) {
        return await this.post(`/desacopio/${presupuestoId}`, { items });
    }
    async cierre(presupuestoId) {
        return await this.post(`/cierre/${presupuestoId}`);
    }
    async datosUpdate(id, formData) {
        return await this.post(`/datos/${id}`, formData);
    }
}

export default new PresupuestoService();
